const fetchCustom = async (url, options = {}) => {
  const method = (options.method || 'GET').toUpperCase();
  const isNonGetRequest = !['GET', 'HEAD', 'OPTIONS', 'TRACE'].includes(method);

  let isCrossOrigin = false;
  try {
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//')) {
      const requestUrl = new URL(url, window.location.origin);
      isCrossOrigin = requestUrl.origin !== window.location.origin;
    }
  } catch (e) {
    console.warn('Invalid URL for CSRF check:', url);
  }

  if (isNonGetRequest && !isCrossOrigin) {
    const csrfTokenElement = document.getElementById('main_layout_attributes');
    const csrfToken = csrfTokenElement?.dataset?.csrf_token;

    if (csrfToken) {
      options = {
        ...options,
        headers: {
          ...options.headers,
          'X-CSRFToken': csrfToken,
        },
      };
    }
  }

  return fetch(url, options);
};

export const callLinkAction = async (links, action, options = {}) => {
  const link = links?.[action];
  let requestUrl = link?.url;
  if (!link) throw new Error(`Action '${action}' not found`);
  if (!requestUrl) throw new Error(`URL for action '${action}' not found`);

  const { query, ...restOptions } = options;
  try {
    const parsed = new URL(requestUrl, window.location.origin);
    if (query && typeof query === 'object') {
      for (const [key, value] of Object.entries(query)) {
        if (value !== undefined && value !== null && value !== '') {
          parsed.searchParams.set(key, String(value));
        }
      }
    }
    requestUrl = parsed.href;
  } catch (e) {
    console.warn('callLinkAction: failed to parse URL', requestUrl, e);
  }

  const fetchOptions = {
    method: link.method || "GET",
    ...restOptions,
    headers: {
      "Content-Type": "application/json",
      ...(restOptions.headers || {}),
    },
  };

  return await fetchCustom(requestUrl, fetchOptions);
}

export default fetchCustom;
